import {
  faLock,
  faTimes,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-modal";
import { updatePassword } from "../../store/actions/auth/authActions";
import {
  ERROR_ALERT,
  toggleShowAlert,
  SUCCESS_ALERT,
} from "../../store/actions/commonActions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Cache } from "aws-amplify";

const customStyles = {
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "32rem",
    height: "32rem",
    margin: "auto",
    gap: "2rem",
    padding: "70px",
    position: "relative", // Add relative positioning
  },
  closeButton: {
    position: "absolute",
    top: "30px", // Adjust top and right values to position the close button
    right: "30px",
    cursor: "pointer",
  },
  lockIcon: {
    width: "45px", // Set the width to 45px
    height: "auto", // Automatically adjust the height
  },
};

class ChangePasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
    };
  }

  togglePasswordVisibility = (field) => {
    // console.log("toggled password");
    this.setState((prevState) => ({
      [field]: !prevState[field],
    }));
  };

  handlePasswordChange = async () => {
    const { oldPassword, newPassword, confirmPassword } = this.state;

    // Validate that newPassword and confirmPassword match
    if (newPassword !== confirmPassword) {
      alert("New Password and Confirm Password do not match.");
      return;
    }

    const userDetails = Cache.getItem("userdata").userDetails;
    const credentials = {
      id: userDetails.id,
      email: userDetails.email,
      oldPassword,
      newPassword,
    };
    const result = await updatePassword(credentials);

    if (result) {
      this.props.toggleShowAlert(
        true,
        SUCCESS_ALERT,
        "Your password has been updated successfully."
      );
    } else {
      this.props.toggleShowAlert(
        true,
        ERROR_ALERT,
        "Password reset error. The credentials are either incorrect, disabled, or does not exist."
      );
    }

    // Implement the password change logic here
    // You can access the old password and new password from this.state
    // Once the password is changed, close the modal
    this.props.onRequestClose();
  };

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.props.onRequestClose}
        contentLabel="Change Password Modal"
        style={customStyles}
      >
        <FontAwesomeIcon
          icon={faTimes}
          style={customStyles.closeButton}
          onClick={this.props.onRequestClose} // Close the modal when the "X" button is clicked
        />
        <FontAwesomeIcon
          icon={faLock}
          flip="horizontal"
          style={customStyles.lockIcon}
        />
        <h2>Change Password</h2>
        <div className="input-container">
          <input
            className="form-control"
            type={this.state.showOldPassword ? "text" : "password"}
            placeholder="Old Password"
            value={this.state.oldPassword}
            onChange={(e) => this.setState({ oldPassword: e.target.value })}
          />
          <div
            className="icon-container"
            onClick={() => this.togglePasswordVisibility("showOldPassword")}
          >
            <FontAwesomeIcon
              icon={this.state.showOldPassword ? faEye : faEyeSlash}
            />
          </div>
        </div>

        <div className="input-container">
          <input
            className="form-control"
            type={this.state.showNewPassword ? "text" : "password"}
            placeholder="New Password"
            value={this.state.newPassword}
            onChange={(e) => this.setState({ newPassword: e.target.value })}
          />
          <div
            className="icon-container"
            onClick={() => this.togglePasswordVisibility("showNewPassword")}
          >
            <FontAwesomeIcon
              icon={this.state.showNewPassword ? faEye : faEyeSlash}
            />
          </div>
        </div>

        <div className="input-container">
          <input
            className="form-control"
            type={this.state.showConfirmPassword ? "text" : "password"}
            placeholder="Re-type New Password"
            value={this.state.confirmPassword}
            onChange={(e) => this.setState({ confirmPassword: e.target.value })}
          />
          <div
            className="icon-container"
            onClick={() => this.togglePasswordVisibility("showConfirmPassword")}
          >
            <FontAwesomeIcon
              icon={this.state.showConfirmPassword ? faEye : faEyeSlash}
            />
          </div>
        </div>

        <div className="d-flex justify-content-between w-100">
          <Button
            style={{ marginRight: "2rem" }}
            onClick={this.handlePasswordChange}
          >
            Save Password
          </Button>
          <Button onClick={this.props.onRequestClose}>Close</Button>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
});

const mapDispatchToProps = (dispatch) => {
  return {
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ChangePasswordModal)
);
